import { render } from "./pdfprueba.vue?vue&type=template&id=680fa5ee"
import script from "./pdfprueba.vue?vue&type=script&lang=js"
export * from "./pdfprueba.vue?vue&type=script&lang=js"

import "./pdfprueba.vue?vue&type=style&index=0&id=680fa5ee&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__